import {
  READ_ACTION,
  LEAD_RESOURCE,
  FRANCHISE,
  DIGITAL_FRANCHISE_PURCHASE,
  FRANCHISE_MANUAL,
  MANAGE_ACTION,
} from "@/constants/resources";

export default [
  {
    path: "/escritorios",
    name: "physical-franchise-list",
    component: () =>
      import("@/modules/franchises/views/PhysicalFranchiseList.vue"),
    meta: {
      resource: FRANCHISE,
      action: READ_ACTION,
      pageTitle: "Escritórios",
    },
  },
  {
    path: "/franquias-digitais",
    name: "franchisees-list",
    component: () => import("@/modules/franchises/views/FranchiseesList.vue"),
    meta: {
      resource: LEAD_RESOURCE,
      action: READ_ACTION,
      pageTitle: "Franquias digitais",
    },
  },
  {
    path: "/compra-franquias-digitais",
    name: "franchisees-purchase-list",
    component: () => import("@/modules/franchises/views/DigitalFranchisePurchaseList.vue"),
    meta: {
      resource: DIGITAL_FRANCHISE_PURCHASE,
      action: MANAGE_ACTION,
      pageTitle: "Compra de Franquias",
    },
  },
  {
    path: "/manuais-do-franqueado",
    name: "franchise-manuals-list",
    component: () =>
      import("@/modules/franchise_manual/views/FranchiseManualsList.vue"),
    meta: {
      resource: FRANCHISE_MANUAL,
      action: READ_ACTION,
      pageTitle: "Manuais do Franqueado",
    },
  },
];
